import $ from 'jquery';
import _ from 'underscore';
import QuestionOpener from 'portlets/site/helper/question-opener/question-opener';
import Vote from 'portlets/site/helper/vote/vote';

export default class {
	constructor(options) {
		const defaults = {
			el: '#supportHelper',
			dom: {
				categories: '.js-helper-categories',
				category: '.js-helper-category',
				content: '.js-helper-content',
				vote: '.js-vote',
				questionTmpl: '#helperQuestionOpenerTemplate',
				categoryTmpl: '#helperQuestionCategoryTemplate'
			},
			classes: {
				category: {
					state: {
						active: 'b-helper__category_state_active'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.init = false;
		return this;
	}

	getDom() {
		this.$categories = this.$el.find(this.options.dom.categories);
		this.$content = this.$el.find(this.options.dom.content);
		this.$vote = this.$el.find(this.options.dom.vote);
		this.$questionTmpl = this.$el.find(this.options.dom.questionTmpl);
		this.questionTmpl = _.template(this.$questionTmpl.html().trim());

		this.$categoryTmpl = this.$el.find(this.options.dom.categoryTmpl);
		this.categoryTmpl = _.template(this.$categoryTmpl.html().trim());
	}

	sortData(items) {
		return items.sort(function (a, b) {return a.order - b.order;});
	}

	setCategory(e) {
		const key = parseInt($(e.currentTarget).attr('data-key') || e);

		if (typeof yotaPortlets.helper[key] != 'undefined') {
			const $set = this.$category.eq(key);
			this.$category.not(':eq(' + key + ')').removeClass(this.options.classes.category.state.active);
			$set.addClass(this.options.classes.category.state.active);
			this.$content.empty();
			yotaPortlets.helper[key].items = this.sortData(yotaPortlets.helper[key].items);
			const questionHtml = this.questionTmpl({data: yotaPortlets.helper[key]});
			this.$content.append(questionHtml);
			this.helperOpener = new QuestionOpener({parent: this, base: $set.data('ancor')}).render();
			this.helperOpener.toggler(0);
			this.vote = new Vote().render();

			if (this.init) {
				this.setHash([$set.data('ancor'), this.helperOpener.getAncor()]);
			}
		}
	}

	categoryBuild() {
		yotaPortlets.helper = this.sortData(yotaPortlets.helper);
		const html = this.categoryTmpl({data: yotaPortlets.helper});
		this.$categories.empty();
		this.$categories.append(html);
		this.$category = this.$categories.find(this.options.dom.category);
	}

	setAncors() {
		for (let i = 0; i < yotaPortlets.helper.length; i++) {
			if (typeof yotaPortlets.helper[i].ancor == 'undefined') {
				yotaPortlets.helper[i].ancor = yotaPortlets.helper[i].category;
			}
			for (let j = 0; j < yotaPortlets.helper[i].items.length; j++) {
				if (typeof yotaPortlets.helper[i].items[j].ancor == 'undefined') {
					yotaPortlets.helper[i].items[j].ancor = yotaPortlets.helper[i].items[j].id;
				}
			}
		}
	}

	getHash() {
		let hash = location.hash.substr(1);
		if (hash.substring(0, 1) === '/') {
			hash = hash.substr(1);
		}

		const data = hash.split('/');

		return [data[0] ? data[0] : '', data[1] ? data[1] : ''];
	}

	onPopState() {
		console.log(location.hash);
		if (location.hash != '#chat' && location.hash != '#') {
			const params = this.getHash();
			let $active = this.$category.filter('.' + this.options.classes.category.state.active);
			this.$el.data('params', params);

			if (params[0] != '') {
				const $activeHashed = this.$category.filter('[data-ancor="' + params[0] + '"]');
				if ($activeHashed.length) {
					$active = $activeHashed;
				}
			}
			$active.click();
			if (params[1] != '') {
				this.helperOpener.setAncor(params[1], true);
			}
		}
	}

	onInit() {
		const params = this.getHash();
		let $active = this.$category.filter('.' + this.options.classes.category.state.active);

		if (params[0] != '') {
			const $activeHashed = this.$category.filter('[data-ancor="' + params[0] + '"]');
			if ($activeHashed.length) {
				$active = $activeHashed;
			}
		}
		$active.click();

		if (params[1] != '') {
			this.helperOpener.setAncor(params[1], true);
		}
		this.init = true;
	}

	setHash(params) {
		let hash = '';
		if (typeof params != 'undefined') {
			hash = params.join('/');
		}

		if (history.state !== null) {
			if (history.state.hash !== hash) {
				window.history.replaceState({hash: hash, params: params}, 'section', hash !== '' ? '#' + hash : ' ');
			}
		} else {
			window.history.replaceState({hash: hash, params: params}, 'section', hash !== '' ? '#' + hash : ' ');
		}
		this.$el.data('params', params);
		return this;
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.helper) {
				this.getDom();
				this.setAncors();
				this.categoryBuild();
				this.$category.on('click', this.setCategory.bind(this));
				this.setCategory(0);

				if (window.history && window.history.pushState) {
					this.$window.on('popstate.helper hashchange.helper', this.onPopState.bind(this));
				} else {
					this.$window.on('hashchange.helper', this.onPopState.bind(this));
				}

				this.onInit();

			} else {
				console.error('The Helper portlet has no data, set data to "yotaPortlets.helper"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/helper/helper.js